module.exports = __webpack_public_path__ + "img/kitware.c1ac8415.svg";